import { Injectable } from '@angular/core';
import {
  Average,
  Distance,
  Volume,
  IUnitType,
  Currency,
  Mileage
} from './../constants/unitsSystem';

@Injectable({
  providedIn: 'root'
})
export class ConversionService {
  constructor() {}

  getUnitLabels(isStandard: boolean): IUnitType {
    return isStandard
      ? {
          // Imperial System
          average: Average.MILES_PER_GALON,
          distance: Distance.MILE,
          volume: Volume.GALLON,
          currency: Currency.USD,
          mileage: Mileage.MILEAGE
        }
      : {
          // Metric System
          average: Average.KILOMETRES_PER_LITRE,
          distance: Distance.KILOMETRE,
          volume: Volume.LITRE,
          currency: Currency.CAD,
          mileage: Mileage.KILOMETER
        };
  }
}
